import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const msnDouble094100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 0.93,
  type: 'Image93x100',
  associationType: 'ImageMedia93X100',
  imagePreviewHeight: 333,
  minimumRequirements: 0,
  minSize: [311, 333],
  localizedText: {
    previewTypeStringKey: _TL_('MSN double carousel'),
    stringKey: _TL_('0.93 : 1'),
    disclaimerMessage: _TL_('This is an example of how your ad could appear on other websites on the Microsoft Advertising Network. The final ad format is likely to change to match the look and feel of the website.'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showShortHeadline: true,
    showShortHeadlineMultiline: true,
    showGradient: true,
  },
  styleOverrides: {
    businessNameWithAds: {
      '& .business-name': {
        fontSize: 11,
        lineHeight: '1.364',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .adslabel': {
        fontSize: 10,
        lineHeight: '1.364',
        margin: '0 5px 0 0',
        background: 'transparent',
        borderRadius: 4,
        color: '#fff',
        fontFamily: '"Segoe UI","Segoe WP",Arial,Sans-Serif',
        fontWeight: 400,
        padding: '.8px 4px',
        border: '.5px solid hsla(0,0%,100%,.3)',
        opacity: 0.7,
      },
    },
    shortHeadline: {
      color: 'white',
      height: 54,
      fontSize: 20,
      lineHeight: 1.3,
      width: 280,
      paddingBottom: 5,
    },
    previewContent: {
      '&:hover': {
        '& .short-headline': {
          textDecoration: 'underline',
        },
      },
      width: 310,
      height: 333,
    },
    textContainer: {
      position: 'absolute',
      color: '#bebebe',
      bottom: 25,
      left: 20,
      fontSize: 10,
      lineHeight: '16px',
    },
    gradient: {
      '&:after': {
        display: 'block',
        position: 'relative',
        backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
        marginTop: -250,
        height: 280,
        width: '100%',
        content: '\'\'',
      },
    },
  },
};

export default msnDouble094100Raw;
